export default __webpack_public_path__ + "static/media/JocksKaraoke.357ed24c.jpeg";